import { FC } from 'react';
import { Popover } from 'antd';

import SvgIcon from '~src/shared/SvgIcon';
import { Mobile, Web } from '~src/styles/containers.sc';
import MobileModal from '~src/shared/mobileModal/MobileModal';
import { KeyTextObj } from '~src/interfaces/translation.interface';

import { HoverImageWrapper, HoverText, InfoIconBox, TextBox } from './hoverImageInfo.sc';

interface Props {
  pictureText: KeyTextObj;
  imageUrl: string;
  infoText: KeyTextObj | string;
  white?: boolean;
}

const HoverImageInfo: FC<Props> = ({ infoText, white, imageUrl, pictureText }: Props) => {
  let info: { key: string; txt: string };
  if (typeof infoText === 'string') {
    info = {
      key: 'from.server',
      txt: infoText,
    };
  } else {
    info = infoText;
  }

  const content = (
    <div>
      <HoverText data-translation={info.key}>{info.txt}</HoverText>
      <HoverImageWrapper>
        <TextBox data-translation={pictureText.key}>{pictureText.txt}</TextBox>
        <img alt="" src={imageUrl} width={420} height={286} />
      </HoverImageWrapper>
    </div>
  );

  const trigger = (
    <InfoIconBox className={white ? 'icon-white' : ''} data-translation={info.key}>
      <SvgIcon name="iconInfo" width="15px" />
    </InfoIconBox>
  );

  return (
    <>
      <Web>
        <Popover placement="rightTop" content={content}>
          {trigger}
        </Popover>
      </Web>
      <Mobile>
        <MobileModal trigger={trigger} content={content} header={trigger} />
      </Mobile>
    </>
  );
};

HoverImageInfo.defaultProps = {
  white: false,
};

export default HoverImageInfo;
